import { Capacitor } from "@capacitor/core";
import { capacitorPreferencesStorage } from "@lib/platform/capacitor-storage";

/**
 * Storage abstraction for web today; Capacitor Preferences / Secure Storage later.
 */
export interface StorageAdapter {
  get(key: string): Promise<string | null>;
  set(key: string, value: string): Promise<void>;
  remove(key: string): Promise<void>;
}

const webStorage: StorageAdapter = {
  async get(key) {
    if (typeof window === "undefined") return null;
    return window.localStorage.getItem(key);
  },
  async set(key, value) {
    window.localStorage.setItem(key, value);
  },
  async remove(key) {
    window.localStorage.removeItem(key);
  },
};

let activeStorage: StorageAdapter = webStorage;

export function getStorage(): StorageAdapter {
  return activeStorage;
}

/**
 * Platform-selected adapter resolved at call time (native → Capacitor
 * Preferences, web → localStorage). Unlike `getStorage()`, this does not depend
 * on the async adapter swap in `PlatformProvider`, so it is safe to use during
 * early bootstrap (before that effect has run).
 */
export function getPlatformStorage(): StorageAdapter {
  return Capacitor.isNativePlatform()
    ? capacitorPreferencesStorage
    : webStorage;
}

/** For future Capacitor migration — swap adapter at app bootstrap. */
export function setStorageAdapter(adapter: StorageAdapter): void {
  activeStorage = adapter;
}
